<div class="container">
    <div class="head-content">
        <div class="head">
            <div class="head__title">{{'label.Title' | translate}}</div>
            <div class="head__dates">{{'label.Dates' | translate}}</div>
            <div class="head__application-date">{{'label.ApplicationDate' | translate}}</div>
            <div class="head__status">{{'label.Status' | translate}}</div>
        </div>
    </div>
    
    <div class="body-content">
        <div  *ngFor="let application of vacancyApplications$ | async"  class="body">
            <div class="body__title">
                <a *ngIf="application.announcementStatus == announcementStatus.Active"
                   class="body__title-announcement body__title-announcement--link" 
                   [routerLink]="['/announcement', application.announcementId]">
                   {{application.title}}
                </a>
                <div *ngIf="application.announcementStatus != announcementStatus.Active" 
                     class="body__title-announcement body__title-announcement--without-link"> 
                     {{application.title}} 
                </div>

                <a *ngIf="!application.isCustomerAnonymous && application.customerStatusId == customerStatus.Active"
                    [routerLink]="['/customer', application.customerId]" 
                    class="body__title-customer body__title-customer--link">
                    {{application.customerName}}
                </a>
                <div *ngIf="application.isCustomerAnonymous || application.customerStatusId != customerStatus.Active"
                    class="body__title-customer body__title-customer--without-link">
                    {{application.customerName}}
                </div>
            </div>
            <div class="body__dates">{{application.announcementPublishDate | date:'M/d/yy'}} - {{application.announcementDeadlineDate | date:'M/d/yy'}}</div>
            <div class="body__aplication-date">{{application.applicationDate | date:'M/d/yy'}}</div>
            <div [ngClass]="{'body__status--approve': application.applicationStatus == applicationStatus.Approved,
                             'body__status--pending': application.applicationStatus == applicationStatus.Pending,
                             'body__status--rejected': application.applicationStatus == applicationStatus.Rejected}"
                 class="body__status"> 
                {{applicationStatusNameMap[application.applicationStatus] | translate}}
            </div>
        </div>

        <div *ngIf="(vacancyApplications$ | async)?.length > 0" class="paging">
            <ng-container *ngIf="{
                pageCount: pageCount$ | async,
                navItems: navItems$ | async,
                currentPage: currentPage$ | async
            } as data">
                <app-paging [currentPage]="data.currentPage" [pageCount]="data.pageCount" [pagingNavItems]="data.navItems" (onPageNav)="onPagignNavigation($event)"></app-paging>
            </ng-container>
        </div>
    </div>
</div>